module.exports = __webpack_public_path__ + "static/media/shell32_144.5ecaa98f.ico";